<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <ShippingDestinyTransportationForm
          v-if="shippingDestinyTransportation"
          :shippingDestinyTransportation="shippingDestinyTransportation"
        />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import ShippingDestinyTransportationForm from "@/components/settings/test-registers/shippingdestinytransportation/ShippingDestinyTransportationForm.vue";

export default {
  name: "ShippingDestinyTransportationEdit",

  components: {
    PageTitle,
    PageRowWrapper,
    ShippingDestinyTransportationForm,
  },

  computed: {
    ...mapState({
      shippingDestinyTransportation: (state) => state.shippingdestinytransportation.shippingDestinyTransportation,
    }),
  },

  methods: {
    ...mapActions("shippingdestinytransportation", ["fetchById"]),
  },

  mounted() {
    this.fetchById(this.$route.params.id);
  },
};
</script>
